import { render, staticRenderFns } from "./DeathDetailModal.vue?vue&type=template&id=bb77cae0&scoped=true"
import script from "./DeathDetailModal.vue?vue&type=script&lang=js"
export * from "./DeathDetailModal.vue?vue&type=script&lang=js"
import style0 from "./DeathDetailModal.vue?vue&type=style&index=0&id=bb77cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb77cae0",
  null
  
)

export default component.exports